import { render } from "./ExecutionPlanStatistics.vue?vue&type=template&id=6a5a6346&scoped=true"
import script from "./ExecutionPlanStatistics.vue?vue&type=script&lang=js"
export * from "./ExecutionPlanStatistics.vue?vue&type=script&lang=js"

import "./ExecutionPlanStatistics.vue?vue&type=style&index=0&id=6a5a6346&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5a6346"]])

export default __exports__